// FormSettingsModal.jsx

import React from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// Components
import Button from 'components/button/Button';
import ModalButtons from 'components/modal/buttons/ModalButtons';
import ModalButtonSection from 'components/modal/buttonsection/ModalButtonSection';
import ModalField from 'components/modal/field/ModalField';
import ModalForm from 'components/modal/form/ModalForm';
import ModalLabel from 'components/modal/label/ModalLabel';
import Modal from 'components/modal/Modal';
import TextInput from 'components/textinput/TextInput';

const FormSettingsModal = ({
  canSave = false,
  description = '',
  isOpen = false,
  isSaving = false,
  onClose,
  onDelete,
  onDescriptionChange,
  onSave,
  onTitleChange,
  title = '',
}) => {
  // ----- DEVICE DETECTION ----- //

  const isMobile = useIsMobile();
  const isBusy = isSaving;
  const showDeleteAction = typeof onDelete === 'function';

  // ----- RENDER ----- //

  return (
    <Modal
      iconKey="dynamic_form"
      isOpen={isOpen}
      title="Form Template Settings"
      width={isMobile ? '100%' : 480}
      onClose={onClose}
    >
      <ModalForm>
        <ModalField>
          <ModalLabel label="Title" />
          <TextInput
            value={title}
            placeholder="Enter a title..."
            onChange={(event) => onTitleChange?.(event.target.value)}
          />
        </ModalField>

        <ModalField>
          <ModalLabel label="Description" />
          <TextInput
            value={description}
            placeholder="Optional description..."
            onChange={(event) => onDescriptionChange?.(event.target.value)}
          />
        </ModalField>
      </ModalForm>

      <ModalButtons>
        {showDeleteAction ? (
          <ModalButtonSection align="START">
            <Button
              disabled={isBusy}
              iconKey="delete"
              label="Delete"
              addon="danger"
              onClick={onDelete}
            />
          </ModalButtonSection>
        ) : null}

        <ModalButtonSection>
          <Button
            disabled={isBusy}
            iconKey="close"
            label="Cancel"
            addon="secondary"
            onClick={onClose}
          />
          <Button
            disabled={isBusy || !canSave}
            iconKey="check"
            label={isBusy ? 'Saving...' : 'Save'}
            addon="primary"
            onClick={onSave}
          />
        </ModalButtonSection>
      </ModalButtons>
    </Modal>
  );
};

// Dev Tools
FormSettingsModal.displayName = 'FormSettingsModal';

export default FormSettingsModal;
